import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { ReturnShipmentPropType } from '../../../../../../../prop-types/return-shipment';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { openEmailReturnLabelModal } from '../../../../../../../store/returns/returns.actions';
import { RETURN_ACTION_SEND_LABEL_CLICKED } from '../../../../../../../constants/analytics-events';
import { Segment } from '../../../../../../../services/analytics-services/segment';

import messages from '../../../../../rate-card/read-only/label-actions/messages';

export const SendReturnLabel = ({ isDisabled = false, returnFulfillment }) => {
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    Segment.trackEvent(RETURN_ACTION_SEND_LABEL_CLICKED, {
      type: RETURN_ACTION_SEND_LABEL_CLICKED,
      enhanced: false,
      fulfillmentId: returnFulfillment?.fulfillmentId,
    });
    dispatch(openEmailReturnLabelModal([returnFulfillment]));
  }, [dispatch, returnFulfillment]);

  return (
    <DropdownMenuItem disabled={isDisabled} onClick={onClick}>
      <FormattedMessage {...messages.sendReturnLabel} />
    </DropdownMenuItem>
  );
};

SendReturnLabel.propTypes = {
  isDisabled: PropTypes.bool,
  returnFulfillment: ReturnShipmentPropType.isRequired,
};
